import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';
import thank_you_desktop from '@/shared/images/Images/thank_you_desktop.jpg';
import thank_you_desktopDark from '@/shared/images/Images/thankyou_desktopdark.png';
import thank_you_mobile from '@/shared/images/Images/thankyou_mobile.png';
import thank_you_mobileDark from '@/shared/images/Images/thankyou_mobiledark.png';
import thank_you_ipad from '@/shared/images/Images/thankyou_ipad.png';
import thank_you_ipadDark from '@/shared/images/Images/thankyou_ipaddark.png';
import { radius } from '@/styles/Themes/Metrics';
import { FlexPresets } from '@/styles/Themes/Presets';
import { Instagram } from '@/shared/images/icons/Instagram';
import { Facebook } from '@/shared/images/icons/Facebook';

export const Container = styled.div`
    position: relative;
    ${Screen.desktop} {
        max-width: 1064px;
        margin: 0 auto;
    }
`;

export const Price = styled.h3`
    color: ${cssVars.fg_gray1_white};
    text-align: center;
    ${Screen.desktop} {
        ${Text.Desktop.heading3};
    }
`;

export const Title = styled.h2`
    color: ${Palette.green.normal};
    text-align: center;
    ${Screen.desktop} {
        ${Text.Desktop.large.medium};
    }
`;

export const PriceWrapper = styled.div`
    ${Text.Mobile.heading4.bold};
    margin: 20px 0 30px;

    ${Screen.desktop} {
        margin: 20px 20px 40px;
    }
`;

export const PriceTitle = styled.div`
    color: ${Palette.green.normal};
    text-align: center;
    ${Text.Full.large.medium};

    ${Screen.desktop} {
        margin: 12px 0;
    }
`;

export const Divider = styled.div`
    border: 1px solid ${cssVars.fg_white_dark};
    margin: 70px auto 124px;
    width: 274px;

    ${Screen.desktop} {
        width: 65vw;
    }
`;

export const DividerWrapper = styled.div`
    width: 274px;
    margin: 0 auto;
    ${Screen.desktop} {
        width: 65vw;
    }
`;

export const LeftRound = styled.div`
    position: relative;
    display: block;
    padding-bottom: 24px;
    text-align: left;
    &::before {
        position: absolute;
        bottom: 140px;
        content: '';
        width: 17px;
        height: 17px;
        border-radius: 50%;
        background-color: ${cssVars.fg_white_dark};
    }
`;

export const CenterRound = styled.div`
    position: relative;
    display: block;
    padding-bottom: 24px;
    text-align: center;
    &::before {
        position: absolute;
        bottom: 165px;
        content: '';
        width: 17px;
        height: 17px;
        border-radius: 50%;
        background-color: ${cssVars.fg_white_dark};
    }
`;

export const RightRound = styled.div`
    position: relative;
    display: block;
    padding-bottom: 24px;
    text-align: right;
    &::before {
        position: absolute;
        bottom: 172px;
        left: 29.5vw;
        ${Screen.desktop} {
            left: 63.7vw;
        }
        content: '';
        width: 51px;
        height: 51px;
        border-radius: 50%;
        opacity: 0.3;
        background-color: ${Palette.green.normal};
    }

    &::after {
        position: absolute;
        bottom: 188px;
        content: '';
        width: 17px;
        height: 17px;
        border-radius: 50%;
        background-color: ${Palette.green.normal};
    }
`;

export const TextWrapper = styled.div`
    position: relative;
    bottom: 15vh;
    display: flex;
    justify-content: space-between;
`;

export const LeftRoundText = styled.div`
    color: ${cssVars.fg_gray1_white};
`;

export const CenterRoundText = styled.div`
    color: ${cssVars.fg_gray1_white};
`;

export const RightRoundText = styled.div`
    color: ${cssVars.fg_gray1_white};
`;

export const ThankyouImage = styled.div<{ isLight: boolean }>`
    width: 292px;
    height: 145px;
    margin: 0 auto;
    padding: 29px 0 10px;
    background-image: ${({ isLight }) =>
        isLight ? `url(${thank_you_mobile.src})` : `url(${thank_you_mobileDark.src})`};

    ${Screen.ipad} {
        width: 502px;
        height: 249px;
        padding: 40px 0 0;
        background-image: ${({ isLight }) =>
            isLight ? `url(${thank_you_ipad.src})` : `url(${thank_you_ipadDark.src})`};
    }
    ${Screen.desktop} {
        width: 692px;
        height: 349px;

        background-image: ${({ isLight }) =>
            isLight ? `url(${thank_you_desktop.src})` : `url(${thank_you_desktopDark.src})`};
    }
`;

export const ImportantInfoWrapper = styled.div`
    padding: 42px 0 0;

    ${Screen.desktop} {
        margin: 71px 0;
        padding: 71px;
        box-shadow: ${cssVars.shadow_container};
        border-radius: ${radius.small};
        background: ${cssVars.bg_white_dark3};
    }
`;

export const ImportantInfoTitle = styled.div`
    ${FlexPresets.flexRowCenter};
    background: ${cssVars.bg_ash_dark2};
    border-radius: ${radius.small};
    height: 55px;
    ${Text.Mobile.large.medium};
    color: ${cssVars.fg_gray2_gray3};

    ${Screen.desktop} {
        max-width: 923px;
        height: 100px;
        text-align: center;
        padding: 4% 0;
        ${Text.Desktop.heading4};
        color: ${cssVars.fg_gray_dark};
    }
`;

export const InfoWrapper = styled.div`
    margin: 42px auto;
`;

export const InfoSteps = styled.div`
    ${Text.Mobile.large.semibold};
    color: ${cssVars.fg_gray1_white};
`;

export const InfoStepsDetails = styled.div`
    ${Text.Desktop.medium.regular};
    color: ${cssVars.fg_gray2_gray3};
    margin: 0 0 30px;

    > span {
        color: ${Palette.green.normal};
    }
`;

export const SocialIconsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    ${Text.Full.large.semibold};
    color: ${cssVars.fg_gray2_gray3};

    ${Screen.desktop} {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const HugeSocialIcons = styled.div`
    display: flex;
    align-items: center;
    border: 0.6px solid ${Palette.green.normal};
    background-color: ${cssVars.bg_white_dark3};
    width: 100%;
    height: 64px;
    border-radius: ${radius.small};
    margin: 5px 0;
    padding: 0 50px;
    cursor: pointer;

    ${Screen.ipad} {
        height: 83px;
        padding: 0 70px;
        margin: 6px 0;
    }

    ${Screen.desktop} {
        width: 49%;
        height: 103px;
        padding: 0 120px;
        margin: 0;
    }
`;

export const FacebookCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: linear-gradient(180deg, #5572b0 0%, #405c98 48.23%, #22438a 100%);
    border-radius: 36px;
    margin-right: 15px;

    ${Screen.ipad} {
        width: 43px;
        height: 43px;
    }
`;

export const InstagramCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: linear-gradient(
        180deg,
        #4c61d3 0%,
        #893fb8 19.06%,
        #c32994 40.42%,
        #ea2a67 56.25%,
        #f05631 73.75%,
        #f7a74b 87.81%,
        #fde174 98.44%
    );
    border-radius: 36px;
    transform: rotate(33deg);
    margin-right: 15px;

    > svg {
        transform: rotate(-33deg);
    }

    ${Screen.ipad} {
        width: 43px;
        height: 43px;
    }
`;

export const InstagramIcon = styled(Instagram)`
    ${Screen.ipad} {
        width: 24px;
        height: 24px;
    }
`;

export const FacebookIcon = styled(Facebook)`
    ${Screen.ipad} {
        width: 24px;
        height: 24px;
    }
`;

export const SkeletonCard = styled.span`
    position: relative;
    display: inline-block;
    width: 100%;
    height: 300px;
    background-color: #f1f1f1;
    &:after {
        position: relative;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.2) 20%,
            rgba(255, 255, 255, 0.5) 60%,
            rgba(255, 255, 255, 0)
        );
        animation: shimmer 2s infinite;
        content: '';
    }

    @keyframes shimmer {
        100% {
            transform: translateX(100%);
        }
    }
`;

export const IfError = styled.h3`
    ${Text.Full.large.semibold};
    color: ${cssVars.fg_gray2_white};
`;

export const ErrorText = styled.div`
    ${Text.Full.medium.regular};
    ${cssVars.fg_gray2_gray3};
`;
